import WooCommerceRestApi from '@woocommerce/woocommerce-rest-api';

const key = process.env.REACT_APP_WOOCOMMERCE_API_KEY;
const secret = process.env.REACT_APP_WOOCOMMERCE_API_SECRET;
const woocommerceUrl = process.env.REACT_APP_WOOCOMMERCE_URL;

console.log(woocommerceUrl, 'woocommerceUrl');

const WoocommerceAPi = new WooCommerceRestApi({
  url: woocommerceUrl,
  consumerKey: key,
  consumerSecret: secret,
  version: 'wc/v3'
});

export default WoocommerceAPi;
